// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'john-lewis-storybook',
  heroImg: 'hero.jpg',
  heroTheme: 'light',
  heroHeadingOne: 'John Lewis',
  heroHeadingTwo: 'Interactive Storybook',
  details: [
    {
      title: 'AGENCY',
      items: ['Adam&EveDDB'],
    },
    {
      title: 'PLATFORM',
      items: ['Dialogflow', 'Firebase', 'Google Home'],
    },
    {
      title: 'LAUNCH',
      items: ['December 2017'],
    },
  ],
  heading: 'Letting children interact with the John Lewis Christmas campaign',
  challengeImg: 'challenge.jpg',
  challenge: false,
  footerImg: false,
  solution: [
    'Combining a story read by Sally Phillips with interactive content to build greater engagement with Moz the Monster character.',
    'The experience uses Google Home to allow children to personalise the story and choose their own sound effects.',
    'Children could select from three different voices for the experience.',
  ],
  nextCaseStudy: 'storycastle',
};

export default casestudyData;
